export const DEVICE_BREAKPOINTS = {
  mobileS: '320px',
  mobileM: '375px',
  mobileL: '425px',
  mobileXL: '479px',
  tabletS: '640px',
  tablet: '768px',
  tabletL: '970px',
  laptop: '1025px',
  yFullHD: '1080px',
  laptopM: '1280px',
  laptopL: '1440px',
  laptopXL: '1640px',
  desktop: '2560px',

  // laptopM: '1126px',
  // laptopML: '1300px',
};
